<template>
    <li :class="`c-checklist__item u-medium ${ customClass ? customClass : ''}`">
        <svgicon class="c-checklist__icon" :name="icon ? icon : 'check'"></svgicon>
        <span><slot></slot></span>
    </li>
</template>

<script>
    export default {
        props: ['custom-class', 'icon']
    }
</script>

<style lang="scss" scoped>

    @import "~@/assets/scss/private";

    .c-checklist__item{
        display: flex;
        align-items: baseline;
        > *{
            &:not(:last-child){
                margin-right: em($global-spacing-unit-small);
            }
        }
    }

    .c-checklist__icon{
        position: relative;
        top: em(3px);
    }
</style>


// WEBPACK FOOTER //
// src/components/checklist/ChecklistItem.vue